import { useMemo } from "react";
import {
  filtersForQuery,
  categoryFiltersForQuery,
  createElasticsearchQueryString,
  filtersToStreamSet,
  filtersToStreamCategorySet
} from "views/logic/queries/Query";
import { timeRangeFromQueryParameter } from "views/logic/TimeRange";
import { DEFAULT_RANGE_TYPE } from "views/Constants";
import useQuery from "routing/useQuery";
const normalizeTimeRange = (query) => (
  // eslint-disable-next-line no-nested-ternary
  query && "rangetype" in query ? timeRangeFromQueryParameter(query) : "relative" in query ? timeRangeFromQueryParameter({ ...query, rangetype: DEFAULT_RANGE_TYPE }) : void 0
);
const normalizeStreams = (query = {}) => {
  const rawStreams = query.streams;
  if (rawStreams === void 0 || rawStreams === null) {
    return [];
  }
  return String(rawStreams).split(",").map((stream) => stream.trim()).filter((stream) => stream !== "");
};
const normalizeStreamCategories = (query = {}) => {
  const rawCategories = query.stream_categories;
  if (rawCategories === void 0 || rawCategories === null) {
    return [];
  }
  return String(rawCategories).split(",").map((category) => category.trim()).filter((category) => category !== "");
};
const normalizeSearchURLQueryParams = (query) => {
  const { q: queryString } = query != null ? query : {};
  const timeRange = normalizeTimeRange(query);
  const streamsFilter = filtersForQuery(normalizeStreams(query));
  const streamCategoriesFilter = categoryFiltersForQuery(normalizeStreamCategories(query));
  const autoRefresh = query == null ? void 0 : query.autorefresh;
  return {
    timeRange,
    autoRefresh,
    streamsFilter,
    streamCategoriesFilter,
    queryString: queryString ? createElasticsearchQueryString(queryString) : void 0
  };
};
export const useSearchURLQueryParams = () => {
  const query = useQuery();
  return useMemo(() => {
    const { timeRange, autoRefresh, queryString, streamsFilter, streamCategoriesFilter } = normalizeSearchURLQueryParams(query);
    return {
      timeRange,
      autoRefresh,
      queryString,
      streams: filtersToStreamSet(streamsFilter).toArray(),
      streamCategories: filtersToStreamCategorySet(streamCategoriesFilter).toArray()
    };
  }, [query]);
};
export default normalizeSearchURLQueryParams;
